"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { Auth } from '@shared/auth';
import { CookieService } from 'ngx-cookie';
import { Observable } from 'rxjs/Observable';
import { TRACKING_CONFIG } from './tracking.config';
import { TrackingConfig } from './tracking.interface';
var Tracking = (function () {
    function Tracking(http, auth, cookies, config) {
        var _this = this;
        this.http = http;
        this.auth = auth;
        this.cookies = cookies;
        this.config = config;
        this.MAX_GET_LENGTH = 2000;
        this.sequenceNum = 0;
        var sessionId = this.cookies.get(this.config.sessionCookie);
        if (!sessionId) {
            // Generate a new one if not.
            sessionId = this.generateSessionId();
            this.cookies.put('_tracking_session', sessionId, {
                expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
            });
        }
        this.sessionId = sessionId;
        // send the event backlog if any
        try {
            var backlog = localStorage.getItem('trackingBacklog');
            if (backlog) {
                var itemsMap = JSON.parse(backlog);
                Object.values(itemsMap).forEach(function (item) {
                    _this.sendBeacon(item);
                });
            }
            localStorage.setItem('trackingBacklog', JSON.stringify({}));
        }
        catch (e) {
            // ignore the errors, e.g. quota is full or security error
            console.error(e);
        }
    }
    Tracking.prototype.track = function (eventName, eventData) {
        var _this = this;
        return this.auth.authState
            .switchMap(function (auth) {
            var e = __assign({
                acct: window.location.hostname.replace(/^www/, ''),
                t: Date.now().toString(),
                en: eventName,
                location: window.location.href,
                user_id: auth ? parseInt(auth.userId, 10) : undefined,
                session_id: _this.sessionId,
            }, eventData);
            return _this.sendBeacon(e);
        })
            .toPromise();
    };
    Tracking.prototype.generateSessionId = function () {
        var s4 = function () {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        };
        return "" + s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
    };
    Tracking.prototype.sendBeacon = function (payload) {
        var _this = this;
        var beaconId = this.sequenceNum++;
        // save the event for later in case of a hard navigation
        try {
            var backlog = JSON.parse(localStorage.getItem('trackingBacklog') || '{}');
            backlog[beaconId] = payload;
            localStorage.setItem('trackingBacklog', JSON.stringify(backlog));
        }
        catch (e) {
            // ignore the errors, e.g. quota is full or security error
            console.error(e);
        }
        return (Observable.of(payload)
            .delay(100)
            .switchMap(function (e) { return _this.http.post(_this.config.trackingEndpoint, e); })
            .do(function () {
            // Remove the event from the backlog once it has been sent
            try {
                var backlog2 = JSON.parse(localStorage.getItem('trackingBacklog') || '{}');
                delete backlog2[beaconId];
                localStorage.setItem('trackingBacklog', JSON.stringify(backlog2));
            }
            catch (e) {
                // ignore the errors, e.g. quota is full or security error
                console.error(e);
            }
        })
            .mapTo(undefined)
            .toPromise()
            .catch(function (err) {
            if (err.error instanceof Error) {
                // A client-side or network error occurred.
                throw err.error;
            }
            else {
                // The backend returned an unsuccessful response code
                throw err.message;
            }
        }));
    };
    Tracking.ctorParameters = function () { return [{ type: HttpClient }, { type: Auth }, { type: CookieService }, { type: TrackingConfig, decorators: [{ type: Inject, args: [TRACKING_CONFIG] }] }]; };
    return Tracking;
}());
export { Tracking };
//# sourceMappingURL=tracking.service.js.map


// WEBPACK FOOTER //
// tracking.service.js